<template>
    <div class="profile-menu" @mouseleave="closeProfileMenuPopup" :class="{'active': isVisibleProfileMenuPopup}">
        <div class="profile-menu-header">
            <div class="menu-close" @click.prevent="closeProfileMenuPopup">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 18 6 6M18 6 6 18" stroke="#747474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="account-dashboard">
                <div class="d-flex flex-column">
                    <router-link to="/account/profile-info" class="account-name">{{profileObj.userNm}}</router-link>
                    <router-link to="/account/profile-info" class="account-id">{{profileObj.emailId}}</router-link>
                </div>
                <router-link to="/account/profile-info"><ProfileUserImg /></router-link>
            </div>
            <router-link to="/yescoin">
                <div class="yescoin-dashboard">
                    <span>예스코인</span>
                    <span class="color-primary"><strong>{{Number(profileObj.yescoinAmt).toLocaleString()}}</strong> P</span>
                </div>
            </router-link>
        </div>
        <div class="profile-menu-body">
            <ul class="menu-links">
                <li>
                    <router-link to="/order-history" class="menu-link">
                        <strong>주문내역</strong>
                        <IconArrowRight></IconArrowRight>
                    </router-link>
                </li>
                <li>
                    <router-link to="/order-history?status=failed" class="menu-link">
                        <span>발송실패 <i class="color-warning">({{profileObj.totalFailCnt > 0 ? profileObj.totalFailCnt : 0}})</i></span>
                        <IconArrowRight></IconArrowRight>
                    </router-link>
                </li>
                <li>
                    <router-link to="/order-history?status=booking" class="menu-link">
                        <span>발송예약 <i class="color-primary">({{profileObj.totalBookingCnt > 0 ? profileObj.totalBookingCnt : 0}})</i></span>
                        <IconArrowRight></IconArrowRight>
                    </router-link>
                </li>
                <li>
                    <router-link to="/account/profile-info" class="menu-link">
                        <strong>회원정보관리</strong>
                        <IconArrowRight></IconArrowRight>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="profile-menu-footer" @click.prevent="logout">
            <span class="color-gray-40">로그아웃</span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    components: {
        IconArrowRight: () => import('@/components/svg-icon/IconArrowRight.vue'),
        ProfileUserImg: () => import('@/components/header/ProfileUserImg.vue'),     // 로그인 유저 프로필 이미지
    },

    props:{
        isVisibleProfileMenuPopup: {
            type: Boolean,
            require: true
        } ,
        profileObj : {
            type: Object,
            require: true
        }
    },

    data() {
        return {
            alarmHas: false,
        }
    },
    
    computed: {
        ...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo
        }),
    },

    methods : {
        closeProfileMenuPopup(){
            this.$emit('updateIsVisibleProfileMenuPopup', false);
        },

        logout() {
            this.dispatchLogoutUser();
        },

        async dispatchLogoutUser() {
            try {
                await this.$store.dispatch('userStore/acitonsLogoutUserApi', {});
                this.$store.commit('setuserNo',null);
                location.reload();
            } catch(err) {
                alert(`${err.response.data.message}`);
                return;
            }
        }
    }
}
</script>


<style lang="scss" scoped>
@import '@/assets/css/header.scss'; /* Header css */
.profile-menu{    
    transition: transform .3s;
    transform: translateX(100%);
    min-width: 100%;
    // transform: translateX(280px);
    // min-width: 280px;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2;
    background: var(--white);
    display: flex;
    flex-direction: column;
    height: 100%;
    box-shadow: var(--box-shadow);

    &.active{
        display: flex;
        transform: translateX(0px);
    }

    @media (min-width: 768px) {
        display: none;
        transform: translateX(0px);
        // position: absolute;
        top: calc(var(--header-height) - 11px);
        right: var(--container-padding);
        height: auto;
        min-width: 280px;
        min-height: 530px;
        border-radius: var(--border-radius);
        overflow: hidden;
    }

    .profile-menu-header{
        padding: var(--container-padding);
        background: var(--secondary);
        color: var(--white);
        display: flex;
        flex-direction: column;
        gap: 16px;

        .menu-close{
            text-align: right;
            svg{
                cursor: pointer;

                path{
                    stroke: var(--white);
                }
            }
        }

        .account-dashboard{
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            line-height: 1;

            .account-name{
                font-size: 16px;
                font-weight: 500;
            }
            .account-id{
                margin-top: 12px;
                font-size: var(--info-font-size);
            }

            .profile-img{
                width: 48px;
                height: 48px;
            }
        }

        .yescoin-dashboard{
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: var(--white);
            border-radius: var(--border-radius);
            height: 36px;
            padding: 0 8px;
            color: var(--black);
            font-size: 14px;
            font-weight: 500;
        }
    }
    .profile-menu-body{
        flex: 1;
        padding: var(--container-padding);
        overflow: auto;

        .menu-link{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 0;
        }
    }
    .profile-menu-footer{
        padding: 0 var(--container-padding);
        border-top: 1px solid var(--gray-20);
        height: 48px;
        line-height: 48px;
        cursor: pointer;
    }
}
</style>